import { API_BASE_URL, API_ENDPOINTS } from '../../constants/api';

export interface Notificacion {
  id: string;
  usuarioId: string;
  titulo: string;
  mensaje: string;
  tipo: string;
  leida: boolean;
  referenciaTipo?: string | null;
  referenciaId?: string | null;
  creadoEn: string;
}

class NotificationsServiceClass {
  private getAuthHeaders() {
    const token = localStorage.getItem('accessToken');
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  async listarMine(limite = 30): Promise<Notificacion[]> {
    const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.notifications.mine}?limite=${limite}`, {
      method: 'GET',
      headers: this.getAuthHeaders(),
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'Error desconocido' }));
      throw new Error(errorData.message || 'Error al listar notificaciones');
    }
    const result = await response.json();
    return result.data || result;
  }

  async contarNoLeidas(): Promise<number> {
    const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.notifications.noLeidas}`, {
      method: 'GET',
      headers: this.getAuthHeaders(),
    });
    if (!response.ok) return 0;
    const result = await response.json();
    const payload = result.data ?? result;
    return payload?.count ?? 0;
  }

  async marcarLeida(id: string): Promise<void> {
    await fetch(`${API_BASE_URL}${API_ENDPOINTS.notifications.marcarLeida(id)}`, {
      method: 'PATCH',
      headers: this.getAuthHeaders(),
    });
  }

  async marcarTodasLeidas(): Promise<void> {
    await fetch(`${API_BASE_URL}${API_ENDPOINTS.notifications.leerTodas}`, {
      method: 'PATCH',
      headers: this.getAuthHeaders(),
    });
  }
}

export const NotificationsService = new NotificationsServiceClass();
